/* eslint-disable no-underscore-dangle */
export * from './@types';
export * from './components';
export * from './contexts';
export * from './constants';
export * from './LegacyMount';

/**
 * Returns true if __debug_mode is set to true in localStorage.
 */
export const isDebugMode = () => {
  const debugMode = localStorage.getItem('__debug_mode');
  return debugMode === 'true' || debugMode === '1' || debugMode === 't';
};

if (isDebugMode()) {
  console.log('************************************************');
  console.log('   Card Tokenization component loaded.');
  // eslint-disable-next-line
  // @ts-ignore
  console.log(
    '   Build version:',
    (window as any)?.__PT_BUILD_VERSION__ ?? 'unknown',
  );
  // eslint-disable-next-line
  // @ts-ignore
  console.log(
    '   Build date:',
    (window as any)?.__PT_BUILD_TIME__ ?? new Date().toISOString(),
  );
  console.log('************************************************');
}
